module.exports = __webpack_public_path__ + "img/3.55db9cd4.png";